import { __values } from "tslib";
import { ProductTypeHelper, SearchMaskGroupType, store } from "ltur-state-engine";
import Vue from "vue-ltur";
import { BaseFilterHelper } from "FilterBar/BaseFilterBar/FilterBars/Helper/BaseFilterHelper";
import format from "date-fns/format";
import fr from "date-fns/locale/fr";
import de from "date-fns/locale/de";
import { DateHelper } from "helper";
var BaseFilterOverviewHelper = /** @class */ (function () {
    function BaseFilterOverviewHelper() {
    }
    BaseFilterOverviewHelper.getOverviewLabel = function (filter) {
        var lturState = store.getState();
        var groupType = ProductTypeHelper.mapToSearchMaskGroupType(lturState.websiteState.app.url.context.productType);
        switch (filter.identifier) {
            case 'childPriceFilter':
                return groupType === SearchMaskGroupType.PACKAGE ? Vue.translate('filter_bar.childprices') : Vue.translate('filter_bar.childprices.hotelonly');
            case 'dealsFilter':
                return Vue.translate('filter_bar.deals');
            case 'earlyBirdFilter':
                return Vue.translate('filter_bar.early_bird');
            case 'lastMinuteDealFilter':
                return Vue.translate('filter_bar.last_minute_deal');
            case 'summerDealFilter':
                return Vue.translate('filter_bar.summer_deal');
            case 'flexFilter':
                return Vue.translate('filter_overview.flex_tarif');
            case 'ulmFilter':
                return Vue.translate('filter_overview.ulm');
            case 'priceFilter':
                var currency = location.pathname.split('/')[1] === 'ch' ? ' Fr.' : ' €';
                var minPrice = filter.model[0].toLocaleString('de-DE') + currency;
                var maxPrice = filter.model[1] === filter.initialValue[1] || filter.initialValue[0]
                    ? Vue.translate('any') : filter.model[1].toLocaleString('de-DE') + currency;
                return "".concat(minPrice, " - ").concat(maxPrice);
            case 'outBoundFlightTimeFliter':
                var minTimeDeparture = filter.model[0].toLocaleString('de-DE', { minimumIntegerDigits: 2 });
                var maxTimeDeparture = filter.model[1].toLocaleString('de-DE', { minimumIntegerDigits: 2 });
                var depTimeSpan = "".concat(minTimeDeparture, ":00 - ").concat(filter.model[1] === filter.initialValue[1] ? '23:59' : maxTimeDeparture + ':00');
                return Vue.translate('filter_overview.departure_timespan').replace('{0}', depTimeSpan);
            case 'inBoundFlightTimeFliter':
                var minTimeReturn = filter.model[0].toLocaleString('de-DE', { minimumIntegerDigits: 2 });
                var maxTimeReturn = filter.model[1].toLocaleString('de-DE', { minimumIntegerDigits: 2 });
                var retTimeSpan = "".concat(minTimeReturn, ":00 -  ").concat(filter.model[1] === filter.initialValue[1] ? '23:59' : maxTimeReturn + ':00');
                return Vue.translate('filter_overview.return_timespan').replace('{0}', retTimeSpan);
            case 'flightStopsFilter':
                return Vue.translate('filter_bar.stops.options', 0);
            case 'transferFilter':
                return Vue.translate('filter_bar.transfer_only_offers');
            case 'preferredDepartureDateFilter':
                var date = /\/fr\//.test(location.href) ?
                    DateHelper.capitalize(format(new Date(filter.model), 'ddd DD.MM.', { locale: fr })) :
                    format(new Date(filter.model), 'dd. DD.MM.', { locale: de });
                return Vue.translate('filter_overview.departure_day') + date;
            case 'trainToFlightFilter':
                return Vue.translate('filter_bar.train_to_flight_offers');
            case 'holidaycheckFilter':
                var rating = new Map([
                    [1903, '1.0'],
                    [1905, '2.0'],
                    [1907, '3.0'],
                    [1909, '4.0'],
                    [1911, '5.0'],
                    [1913, '6.0']
                ]).get(filter.model);
                return Vue.translate('filter_overview.hc_rating').replace('{0}', rating);
            case 'recommendationFilter':
                return Vue.translate('filter_overview.recommendation').replace('{0}', filter.model[0]);
            case 'seaViewRoomFilter':
                return Vue.translate('filter_bar.room_type.sea_view_room');
            default:
                return;
        }
    };
    BaseFilterOverviewHelper.filterOverview = function (filterList) {
        var e_1, _a;
        var _b;
        var output = [];
        var _loop_1 = function (filter) {
            var filterData = JSON.parse(JSON.stringify(filter));
            if (filterData.items) {
                if (Array.isArray(filterData.model)) {
                    var _loop_2 = function (i) {
                        if (filterData.model[i]) {
                            output.push({
                                label: filterData.items[i].name,
                                remove: function () {
                                    filterData.model[i] = filterData.initialValue[i];
                                    filter.setFilter(filterData.model, true);
                                }
                            });
                        }
                    };
                    for (var i = 0; i < filterData.model.length; i++) {
                        _loop_2(i);
                    }
                }
                else {
                    output.push({
                        label: (_b = filterData.items.find(function (x) { return x.id === filterData.model; })) === null || _b === void 0 ? void 0 : _b.name,
                        remove: filter.setFilter.bind(this_1, filter.initialValue, true)
                    });
                }
                return "continue";
            }
            var label = BaseFilterOverviewHelper.getOverviewLabel(filterData);
            if (label)
                output.push({
                    label: label,
                    remove: filter.setFilter.bind(this_1, filter.initialValue, true)
                });
        };
        var this_1 = this;
        try {
            for (var filterList_1 = __values(filterList), filterList_1_1 = filterList_1.next(); !filterList_1_1.done; filterList_1_1 = filterList_1.next()) {
                var filter = filterList_1_1.value;
                _loop_1(filter);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (filterList_1_1 && !filterList_1_1.done && (_a = filterList_1.return)) _a.call(filterList_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return output;
    };
    BaseFilterOverviewHelper.isFilterOverviewActive = function () {
        return BaseFilterOverviewHelper.filterOverviewData.length > 0;
    };
    BaseFilterOverviewHelper.updateFilterOverviewData = function () {
        BaseFilterOverviewHelper.filterOverviewData = BaseFilterOverviewHelper.filterOverview(BaseFilterHelper.filterBar.userFilter());
        document.dispatchEvent(new CustomEvent('onFilterOverviewUpdated'));
    };
    BaseFilterOverviewHelper.resetFilterOverview = function () {
        BaseFilterHelper.filterBar.reset();
        this.updateFilterOverviewData();
    };
    BaseFilterOverviewHelper.filterOverviewData = [];
    return BaseFilterOverviewHelper;
}());
export { BaseFilterOverviewHelper };
